// Map every detected_signal to a humanized label + a risk-driven color palette.
// Colors match the earthy design system: terracotta (risky), ochre (needs softening),
// sage (good), and stone (neutral fallback).

const RISK_PALETTE = {
    risky: {
        chip: "bg-[#F7EBE8] text-[#A35741] border-[#F2D6D0]",
        dot: "bg-[#C1664D]",
    },
    needs_softening: {
        chip: "bg-[#FAEFE1] text-[#A06F3A] border-[#F0E0C6]",
        dot: "bg-[#C98A4F]",
    },
    good: {
        chip: "bg-[#EAF1E8] text-[#4B6143] border-[#D5E3D1]",
        dot: "bg-[#5E7153]",
    },
    neutral: {
        chip: "bg-stone-100 text-stone-600 border-stone-200",
        dot: "bg-stone-400",
    },
};

const SIGNAL_TO_RISK = {
    // High risk
    accusatory: "risky",
    dismissive: "risky",
    passive_aggressive: "risky",
    threatening: "risky",
    contemptuous: "risky",
    // Medium risk
    frustrated: "needs_softening",
    defensive: "needs_softening",
    abrupt: "needs_softening",
    cold: "needs_softening",
    pressuring: "needs_softening",
    // Low risk / positive
    neutral: "neutral",
    constructive: "good",
    appreciative: "good",
    apologetic: "good",
    // Newly added positive signals — same UI bucket as other "good" tones.
    empathetic: "good",
    assertive: "good",
    solution_focused: "good",
};

const SIGNAL_TO_LABEL = {
    accusatory: "Accusatory",
    dismissive: "Dismissive",
    passive_aggressive: "Passive-Aggressive",
    threatening: "Threatening",
    contemptuous: "Contemptuous",
    frustrated: "Frustrated",
    defensive: "Defensive",
    abrupt: "Abrupt",
    cold: "Cold",
    pressuring: "Pressuring",
    neutral: "Neutral",
    constructive: "Constructive",
    appreciative: "Appreciative",
    apologetic: "Apologetic",
    empathetic: "Empathetic",
    assertive: "Assertive",
    solution_focused: "Solution-Focused",
};

// Legacy coarse-tone fallback mapping for older messages stored in localStorage
// before the signal schema landed.
const LEGACY_TONE_TO_SIGNAL = {
    anger: "accusatory",
    frustration: "frustrated",
    sarcasm: "passive_aggressive",
    neutral: "neutral",
    positive: "appreciative",
};

export const getSignalMeta = ({ signal, risk, tone } = {}) => {
    let key = signal && SIGNAL_TO_LABEL[signal] ? signal : null;
    if (!key && tone && LEGACY_TONE_TO_SIGNAL[tone]) {
        key = LEGACY_TONE_TO_SIGNAL[tone];
    }
    if (!key) key = "neutral";
    const riskKey =
        (risk && RISK_PALETTE[risk]) ? risk : SIGNAL_TO_RISK[key] || "neutral";
    return {
        signal: key,
        label: SIGNAL_TO_LABEL[key] || "Neutral",
        risk: riskKey,
        ...RISK_PALETTE[riskKey],
    };
};

export { RISK_PALETTE, SIGNAL_TO_RISK, SIGNAL_TO_LABEL };
